export enum ENUM_PIX_TYPE {
  CPF = 'CPF',
  CNPJ = 'CNPJ',
  PHONE = 'Celular',
  EMAIL = 'E-mail',
  EVP = 'Aleatória',
  RANDOM = 'Aleatória',
}
